import * as React from 'react';
import * as styles from './LayoutBlock.css';

interface ILayoutBlockBaseProps {
  'data-mark'?: string;
  'data-name'?: string;
  'data-testid'?: string;
  children: React.ReactNode;
  id?: string;
}

type TLayoutBlockProps =
  | (ILayoutBlockBaseProps & {
      as?: 'div';
      ref?: React.Ref<HTMLDivElement>;
    })
  | (ILayoutBlockBaseProps & {
      as: 'span';
      ref?: React.Ref<HTMLSpanElement>;
    });

/**
 * Представляет секцию в основном контенте страницы.
 */
export function LayoutBlock({ children, as, ref, ...props }: TLayoutBlockProps): React.JSX.Element {
  if (as === 'span') {
    return (
      <span {...props} ref={ref} className={styles['block']}>
        {children}
      </span>
    );
  }

  return (
    <div {...props} ref={ref} className={styles['block']}>
      {children}
    </div>
  );
}
